<template>
  <div class="background-color-box" :style="backgroundStyle">
    <img
      v-if="config.property_data.icon_url"
      :src="config.property_data.icon_url"
      style="width: 100%"
    />
    <div class="content">
      <span class="text" :style="{ ...textStyle }">{{
        config.property_data.time_text
      }}</span>
      <span class="time text" :style="{ ...timeStyle, ...textStyle }">{{
        timeObj.day
      }}</span>
      <span class="text" :style="textStyle">天</span>
      <span class="time text" :style="{ ...timeStyle, ...textStyle }">{{
        timeObj.hour
      }}</span>
      <span class="text" :style="textStyle">时</span>
      <span class="time text" :style="{ ...timeStyle, ...textStyle }">{{
        timeObj.minute
      }}</span>
      <span class="text" :style="textStyle">分</span>
      <span class="time text" :style="{ ...timeStyle, ...textStyle }">{{
        timeObj.second
      }}</span>
      <span class="text" :style="textStyle">秒</span>
    </div>
  </div>
</template>

<script>
export default {
  props: ["config"],
  watch: {
    "config.property_data.time_number": {
      handler: function (val) {
        if (val) {
          this.ms = new Date(val).getTime() - new Date().getTime();
        } else {
          this.ms = 0;
        }
        this.handleCountDown();
      },
      immediate: true,
    },
  },
  computed: {
    timeObj() {
      let time = Math.ceil(this.ms / 1000);
      const second = time % 60;
      const minute = ((time - second) / 60) % 60;
      const hour = ((time - second - minute * 60) / (60 * 60)) % 24;
      const day =
        (time - second - minute * 60 - hour * 60 * 60) / (60 * 60 * 24);

      return {
        day: String(day).padStart(2, "0"),
        hour: String(hour).padStart(2, "0"),
        minute: String(minute).padStart(2, "0"),
        second: String(second).padStart(2, "0"),
      };
    },
    textStyle() {
      return {
        color: this.config.property_data.text_color,
      };
    },
    timeStyle() {
      return {
        "background-color": this.config.property_data.time_color,
      };
    },
    backgroundStyle() {
      return {
        height: this.config.property_data.icon_url ? "auto" : "48px",
        "background-color": this.config.property_data.icon_url
          ? "transparent"
          : this.config.property_data.background_color,
      };
    },
  },
  data() {
    return {
      ms: 0,
      timeMark: null,
    };
  },
  created() {},
  methods: {
    handleCountDown(timeout = 1000) {
      clearInterval(this.timeMark);
      this.timeMark = setInterval(() => {
        if (this.ms === 0) {
          clearInterval(this.timeMark);
          return;
        }
        this.ms -= timeout;
        if (this.ms < 0) {
          this.ms = 0;
        }
      }, timeout);
      this.$once("hook:beforeDestroy", () => {
        clearInterval(this.timeMark);
      });
    },
  },
};
</script>

<style  lang="scss" scoped>
@import "./index.scss";
</style>
